<ng-container i18n>Cut card</ng-container>
